export const ALL = '';
export const PENDING = 'pending';
export const IN_PROGRESS = 'in_progress';
export const CANCELED_AND_COMPLETED = 'completed-canceled';
export const RECURRENCE = 'recurrence';
export const COMPLETED = 'completed';
export const CANCELED = 'canceled';
